import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ width: "56", height: "56", viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }, this.props),
            React.createElement("g", { fill: "#FFF", fillRule: "evenodd" },
                React.createElement("path", { d: "M28 53c13.807 0 25-11.193 25-25S41.807 3 28 3 3 14.193 3 28s11.193 25 25 25zm0 3C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z" }),
                React.createElement("path", { d: "M29.637 36.249L29.71 40h-2.957l.072-3.63C24.181 36.1 22.68 34.688 22 34.082l2.012-2.83c.727.678 2.302 1.737 4.267 1.737 1.382 0 2.06-.659 2.06-1.532 0-.97-.776-1.396-2.641-2.246l-1.456-.662c-2.52-1.116-3.563-2.624-3.563-4.565 0-2.62 1.939-4.892 4.46-5.352L27.043 15H30l-.072 3.629c2.327.39 3.417 1.863 3.613 2.132l-2.11 2.628a4.46 4.46 0 0 0-3.152-1.317c-1.261 0-1.916.687-1.916 1.585 0 .994.897 1.546 2.425 2.248l1.188.544C32.74 27.709 34 28.959 34 31.263c0 2.183-1.454 4.428-4.363 4.986" })));
    };
    return SVG;
}(React.Component));
export default SVG;
